import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class StarModel extends ModeModelBase {
  override _name = 'star';
  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override attributes = [];
}

@Injectable({ providedIn: 'root' })
export class StarModelAccessor extends ModelAccessorBase<StarModel> {
  override name = 'star';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = ['report'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.star');
  }

  createModel(resource, opts?) {
    const model = new StarModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
